var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hasPromotions)?_c('button',{staticClass:"promo-badge",attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.openDeal();}}},[_vm._v("\n  🔥 "+_vm._s(_vm.$t("mylist.deals.seeDeals"))+"\n")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }